import { Box, Button, Text } from '@streamelements/frontend-ui';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchValidation = z.object({
  title: z.string(),
  message: z.string(),
});

export const Route = createFileRoute('/exception/notify')({
  component: ExceptionNotifyPage,
  validateSearch: searchValidation,
  loaderDeps: ({ search }) => ({
    messages: decodeURIComponent(search.message).split('\n'),
    title: decodeURIComponent(search.title),
  }),
  loader: async ({ deps }) => {
    return deps;
  },
});

function ExceptionNotifyPage() {
  const { messages, title } = Route.useLoaderData();
  return (
    <Box
      css={{
        size: '100%',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
      }}
    >
      <Text.Subtitle weight="bold">{title}</Text.Subtitle>

      {messages.map((message, index) => (
        <Text.Body key={index} css={{ color: '$textPrimary70', px: '2rem', mb: '0.25rem' }}>
          {message}
        </Text.Body>
      ))}

      <Button density="compact" css={{ mt: '1.5rem' }} onClick={() => window.host.endModalDialog(true, () => void 0)}>
        Continue
      </Button>
    </Box>
  );
}
